import * as React from "react";

import { NestedTypeahead, NestedOption } from "../../components/NestedTypeahead";
import { Division } from "../../models/Division";

interface Props
{
    selectedId: number;
    divisions: Division[];
    onChange: (division: Division) => void;
    className?: string;    
}

interface State
{
    options: NestedOption[];
}

// DivisionSelector component is a wrapper around NestedTypeahead
// This component has private methods to convert plain Division list into hierarchical structure
export class DivisionSelector extends React.Component<Props, State>
{
    constructor(props: Props)
    {
        super(props);
        this.state = { options: this.getOptions(props.divisions) };
    }

    componentWillReceiveProps(nextProps: Readonly<Props>, nextContext: any)
    {
        this.setState({ options: this.getOptions(nextProps.divisions) });
    }

    render()
    {
        const { onChange, selectedId, ...rest } = this.props;
        const { options } = this.state;
        const selectedOption = options.find(opt => opt.option.id === selectedId);
        return (
            <NestedTypeahead className={this.props.className}
                labelKey={division => division.Name}
                options={options}
                selected={selectedOption}
                onChange={(selected: NestedOption[]) => onChange(selected.length > 0 ? selected[0].option : null)}
                {...rest}
            />
        );
    }

    getOptions(divisions: Division[]): NestedOption[]
    {
        const idToNode = new Map<number, Node>(); // space: O(n)
        divisions.forEach(d => idToNode.set(d.id, { value: d, children: [] })); // time: O(n)

        const roots: Node[] = [];
        const completed = new Set<number>();

        divisions.forEach(d => {
            let cur = idToNode.get(d.id);
            while(cur) {
                if(completed.has(cur.value.id)) break;
                completed.add(cur.value.id);
                
                const parent = idToNode.get(cur.value.ParentId);
                if(parent) {
                    parent.children.push(cur);
                } else {
                    roots.push(cur);
                }
                cur = parent;
            }
        });
        
        const options: NestedOption[] = [];
        roots.forEach(root => this.dfs(root, 0, options));
        return options;
    }

    // Depth first search
    dfs(node: Node, level: number, result: NestedOption[])
    {
        result.push({ level, option: node.value });
        node.children.forEach(child => this.dfs(child, level + 1, result));
    }
}

interface Node
{
    value: Division;
    children: Node[];
}


// WEBPACK FOOTER //
// ./src/app/components/DivisionSelector.tsx